import icons from '../../img/icons.svg';
import View from './View.js';
import { RES_PER_PAGE } from '../config.js';

class PaginationView extends View {
    _parentElement = document.querySelector('.pagination');
    
    // Implementing event delegation for the buttons
    addHandlerClick(handler) {
        this._parentElement.addEventListener('click', function(e) {
            const btn = e.target.closest('.btn--inline');
            if (!btn) return;
            const goToPage = +btn.dataset.goto;
            handler(goToPage);
        });
    }
    // For computing which buttons should be displayed, we will have to use the entire 'search'
    // object from the model
    _generateButtonMarkup(pos, currPage) {
        if(pos === "next") {
            return `
            <button data-goto="${currPage + 1}" class="btn--inline pagination__btn--next">
                <span>Page ${currPage + 1}</span>
                <svg class="search__icon">
                    <use href="${icons}#icon-arrow-right"></use>
                </svg>
            </button>
            `;
        }
        if(pos === "prev") {
            return `
            <button data-goto="${currPage - 1}" class="btn--inline pagination__btn--prev">
                <svg class="search__icon">
                    <use href="${icons}#icon-arrow-left"></use>
                </svg>
                <span>Page ${currPage - 1}</span>
            </button>
            `;
        }
    }
    
    _generateMarkup() {
        const currPage = this._data.page;
        const numPages = Math.ceil(this._data.results.length / RES_PER_PAGE);
        console.log('numpages:', numPages);
        // console.log(Math.ceil(5.9)); // 6
        // Page 1, and there are other pages
        if(currPage === 1 && numPages > 1) {
            return this._generateButtonMarkup('next', currPage);
        }

        // Last page 
        // (We added 'numPages' greater than 1 because otherwise we would enter this condition when is the last page
        //  and when there is only one page)
        if(currPage === numPages && numPages > 1) {
            return this._generateButtonMarkup('prev', currPage);
        }

        // Other page
        if(this._data.page < numPages) {
            return this._generateButtonMarkup('prev', currPage) + this._generateButtonMarkup('next', currPage);
        }

        // Page 1, and there are NO other pages, the ultimate else of all those conditions
        // We return an empty string because we don't want to display any buttons
        return '';
    }
}


export default new PaginationView();